import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

var HelpText = function HelpText(_a) {
  var children = _a.children,
    className = _a.className,
    icon = _a.icon,
    text = _a.text,
    appearance = _a.appearance,
    inverted = _a.inverted,
    rest = __rest(_a, ["children", "className", "icon", "text", "appearance", "inverted"]);
  var helpTextIcon = icon && jsx("div", {
    className: classNames('cogs-v10', 'cogs-helptext--helptext-line--icon'),
    children: icon
  });
  return jsxs("span", Object.assign({
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-helptext', "cogs-helptext--" + appearance].concat(getThemeClassNames(inverted), [className]))
  }, rest, {
    children: [children, typeof text === 'string' ? jsxs("span", {
      className: classNames('cogs-v10', 'cogs-helptext--helptext-line'),
      children: [helpTextIcon, text]
    }) : text === null || text === undefined ? undefined : text.map(function (line) {
      return jsxs("span", {
        className: classNames('cogs-v10', 'cogs-helptext--helptext-line'),
        children: [helpTextIcon, line]
      }, line);
    })]
  }));
};

export { HelpText };
